/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CostAdderVehicleTypeAddersInner model module.
 * @module model/CostAdderVehicleTypeAddersInner
 * @version 0.0.2
 */
class CostAdderVehicleTypeAddersInner {
    /**
     * Constructs a new <code>CostAdderVehicleTypeAddersInner</code>.
     * @alias module:model/CostAdderVehicleTypeAddersInner
     */
    constructor() { 
        
        CostAdderVehicleTypeAddersInner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
        obj['adder'] = 0.0;
    }

    /**
     * Constructs a <code>CostAdderVehicleTypeAddersInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CostAdderVehicleTypeAddersInner} obj Optional instance to populate.
     * @return {module:model/CostAdderVehicleTypeAddersInner} The populated <code>CostAdderVehicleTypeAddersInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CostAdderVehicleTypeAddersInner();

            if (data.hasOwnProperty('vehicleTypeId')) {
                obj['vehicleTypeId'] = ApiClient.convertToType(data['vehicleTypeId'], 'String');
            }
            if (data.hasOwnProperty('adder')) {
                obj['adder'] = ApiClient.convertToType(data['adder'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CostAdderVehicleTypeAddersInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CostAdderVehicleTypeAddersInner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['vehicleTypeId'] && !(typeof data['vehicleTypeId'] === 'string' || data['vehicleTypeId'] instanceof String)) {
            throw new Error("Expected the field `vehicleTypeId` to be a primitive type in the JSON string but got " + data['vehicleTypeId']);
        }

        return true;
    }


}



/**
 * The vehicleTypeId for which this cost adder applies. If not provided, then the cost adder will apply to all vehicle types.
 * @member {String} vehicleTypeId
 */
CostAdderVehicleTypeAddersInner.prototype['vehicleTypeId'] = undefined;

/**
 * The adder to apply to the base cost metric (duration or distance) for this vehicle type.
 * @member {Number} adder
 * @default 0.0
 */
CostAdderVehicleTypeAddersInner.prototype['adder'] = 0.0;






export default CostAdderVehicleTypeAddersInner;

